import {Component, EventEmitter, Input, numberAttribute, OnChanges, Output} from '@angular/core';

import {FonteIconeComponent, MarkdownPipe} from '../../../../val-composants-lib/src/public-api';
import {ServicesPreferencesService} from '../../../../../val-ammon-services/val-services-lib/src/lib/val-services-preferences.service';

//Préférence d’état du bandeau, mémorisée par recherche et par utilisateur
//  Seul l’écart au défaut (ouvert) est stocké : un bandeau rouvert supprime la préférence.
interface PreferenceBandeau
{
  ouvert: boolean;
}

//Composant bandeau recherche
@Component (
{
  selector: 'val-bandeau-recherche',
  imports:
  [
    MarkdownPipe,
    FonteIconeComponent
  ],
  templateUrl: './bandeau-recherche.component.html',
  styleUrl: './bandeau-recherche.component.scss',
})
export class BandeauRechercheComponent implements OnChanges
{
  //Création
  //  Paramètres
  //    servicesPreferencesService : Service des préférences de l’utilisateur
  constructor (private servicesPreferencesService: ServicesPreferencesService)
  {
    this.ouvert = true;
    this.rafraichir = new EventEmitter<void>;
    this.identifiantRecherche = "";
    this.codePreferenceChargee = "";
    this.basculeDepuisChargement = false;
  }

  //Lignes
  @Input ()
  public lignes!: string[];

  //Taille
  @Input ({transform: numberAttribute})
  public taille!: number;

  //Identifiant de la recherche : clé de la préférence d’état du bandeau
  @Input ()
  public identifiantRecherche: string;

  //Evénement rafraichir
  @Output ()
  public rafraichir: EventEmitter<void>;

  //Indique si ouvert
  public ouvert: boolean;

  //Code de la préférence déjà chargée (évite de relire à chaque changement d’entrée)
  private codePreferenceChargee: string;

  //Indique si l’utilisateur a basculé le bandeau pendant la lecture de la préférence
  private basculeDepuisChargement: boolean;

  //Charge la préférence dès que la recherche est connue et qu’elle a un bandeau
  public ngOnChanges () : void
  {
    let code: string;

    if (!this.identifiantRecherche || !(this.taille > 0))
      return;

    code = this.CodePreference ();

    if (code !== this.codePreferenceChargee)
    {
      this.codePreferenceChargee = code;

      this.ChargerPreference (code);
    }
  }

  //Ouvrir fermer le bandeau
  public OuvrirFermer () : void
  {
    this.ouvert = !this.ouvert;
    this.basculeDepuisChargement = true;

    this.EnregistrerPreference ();
  }

  //Rafraichir le bandeau
  public Rafraichir () : void
  {
    this.rafraichir.emit ();
  }

  //Code de la préférence : search.bandeau.<identifiant de la recherche>
  //  En minuscules : l’identifiant arrive tantôt de l’API (minuscules), tantôt de l’écran appelant (majuscules).
  private CodePreference () : string
  {
    return `search.bandeau.${this.identifiantRecherche.toLowerCase ()}`;
  }

  //Lit la préférence et l’applique
  //  Dégradation silencieuse : Ammon Services injoignable ou en erreur, le bandeau reste ouvert.
  //  Paramètres
  //    code : Code de la préférence
  private async ChargerPreference (code: string) : Promise<void>
  {
    let preference;

    this.basculeDepuisChargement = false;

    try
    {
      const valApiResultat = await this.servicesPreferencesService.RetournerPreferences<PreferenceBandeau> (code);

      if (valApiResultat?.status !== "success" || this.basculeDepuisChargement || code !== this.CodePreference ())
        return;

      preference = valApiResultat.resultat?.find (prf => prf.code === code);

      if (typeof preference?.valeur?.ouvert === "boolean")
        this.ouvert = preference.valeur.ouvert;
    }
    catch
    {
    }
  }

  //Enregistre l’état courant : supprime la préférence s’il est revenu au défaut (ouvert)
  //  Dégradation silencieuse : un échec laisse le bandeau dans l’état choisi, sans message.
  private async EnregistrerPreference () : Promise<void>
  {
    let code: string;

    if (!this.identifiantRecherche)
      return;

    code = this.CodePreference ();

    try
    {
      if (this.ouvert)
        await this.servicesPreferencesService.SupprimerPreference (code);
      else
        await this.servicesPreferencesService.EnregistrerPreference<PreferenceBandeau> (code, {ouvert: false});
    }
    catch
    {
    }
  }
}
